import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { securityAuthenticationChangeEmailAsyncSlice } from './patch';

export const securityAuthenticationChangeEmailReducers = combineReducers({
	patch: securityAuthenticationChangeEmailAsyncSlice.asyncReducers
});

export const securityAuthenticationChangeEmailWatchers = combineAllWatchers([
	securityAuthenticationChangeEmailAsyncSlice.asyncWatchers
]);
